import { render, staticRenderFns } from "./CompGamificationButtons.vue?vue&type=template&id=63cf62f6&scoped=true"
import script from "./CompGamificationButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./CompGamificationButtons.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompGamificationButtons.vue?vue&type=style&index=0&id=63cf62f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cf62f6",
  null
  
)

export default component.exports